"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constantes_1 = require("./constantes");
exports.types = {};
function registerPieceType(t) {
    exports.types[t.key] = t;
    return t;
}
exports.registerPieceType = registerPieceType;
function getPieceType(key) {
    return exports.types[key];
}
exports.getPieceType = getPieceType;
function makeMove(x, y, repeat, condition) {
    if (repeat === void 0) { repeat = 1; }
    if (condition === void 0) { condition = null; }
    return { x: x, y: y, repeat: repeat, condition: condition };
}
exports.makeMove = makeMove;
exports.King = registerPieceType({
    key: 'k',
    movements: [
        makeMove(0, 1),
        makeMove(1, 1),
        makeMove(-1, 1),
        makeMove(1, -1),
        makeMove(-1, -1),
        makeMove(0, -1),
        makeMove(1, 0),
        makeMove(-1, 0),
    ],
});
exports.Queen = registerPieceType({
    key: 'q',
    movements: [
        makeMove(1, 0, 8),
        makeMove(1, 1, 8),
        makeMove(1, -1, 8),
        makeMove(0, 1, 8),
        makeMove(0, -1, 8),
        makeMove(-1, 0, 8),
        makeMove(-1, 1, 8),
        makeMove(-1, -1, 8),
    ],
    canPromote: true,
});
exports.Bishop = registerPieceType({
    key: 'b',
    movements: [
        makeMove(1, 1, 8),
        makeMove(1, -1, 8),
        makeMove(-1, 1, 8),
        makeMove(-1, -1, 8),
    ],
    canPromote: true,
});
exports.Knight = registerPieceType({
    key: 'n',
    movements: [
        makeMove(-1, 2),
        makeMove(1, 2),
        makeMove(-1, -2),
        makeMove(1, -2),
        makeMove(-2, 1),
        makeMove(-2, -1),
        makeMove(2, 1),
        makeMove(2, -1),
    ],
    canPromote: true,
});
exports.Rook = registerPieceType({
    key: 'r',
    movements: [
        makeMove(1, 0, 8),
        makeMove(0, 1, 8),
        makeMove(0, -1, 8),
        makeMove(-1, 0, 8),
    ],
    canPromote: true,
});
var canPawnDoubleMove = function (from) {
    return from.piece.color === constantes_1.White ? from.y <= 2 : from.y >= 5;
};
var pawnMove = function (from, to, repeat, getSquare) {
    return ((repeat === 0 || (repeat === 1 && canPawnDoubleMove(from))) &&
        to.piece === null);
};
var pawnKill = function (from, to, repeat, getSquare) {
    return !!to.piece;
};
exports.Pawn = registerPieceType({
    key: '',
    movements: [
        makeMove(0, 1, 2, pawnMove),
        makeMove(1, 1, 1, pawnKill),
        makeMove(-1, 1, 1, pawnKill),
    ],
});



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/pieces.js
 ** module id = 2
 ** module chunks = 0
 **/